import axios, { redirectToErrorPage } from './axios-config';
import { IDeleteRequest, IUploadRequest, IUploadResponse } from '../models';
import { addTrackingHeader, buildApiEndpoint, getRequestBody } from '../helper-fns/apiHelper';

export const UploadService = {
	upload: async (body: IUploadRequest): Promise<IUploadResponse> =>
		await axios
			.post(buildApiEndpoint('/toll/addOfferPicture'), getRequestBody({ body }), addTrackingHeader())
			.then(({ data }) => data)
			.catch(() => {
				redirectToErrorPage();
			}),
	delete: async (body: IDeleteRequest) =>
		await axios
			.post(buildApiEndpoint('/toll/removeOfferPicture'), getRequestBody({ body }), addTrackingHeader())
			.then(({ data }) => data)
			.catch(() => {
				redirectToErrorPage();
			}),
};
